<section class="ciclo-vida-timeline">
  <div class="ciclo-vida-timeline__top">
    <span class="ciclo-vida-timeline__eyebrow">
      <i class="fas fa-sync-alt" aria-hidden="true"></i>
      Ciclo de Vida do Produto
    </span>
    <span class="ciclo-vida-timeline__cycle-pill" *ngIf="textoCiclo">
      <i class="far fa-clock" aria-hidden="true"></i>
      {{ textoCiclo }}
    </span>
  </div>

  <ol class="ciclo-vida-timeline__steps">
    <ng-container *ngFor="let etapa of fases; let i = index; let primeiro = first">
      <li
        class="ciclo-vida-timeline__connector"
        [ngClass]="'ciclo-vida-timeline__connector--' + fases[i - 1].cor"
        [class.ciclo-vida-timeline__connector--filled]="fases[i - 1].fase < faseAtiva"
        *ngIf="!primeiro"
        aria-hidden="true"
      ></li>
      <li
        class="ciclo-vida-timeline__step"
        [ngClass]="'ciclo-vida-timeline__step--' + etapa.cor"
        [class.ciclo-vida-timeline__step--active]="etapa.fase === faseAtiva"
        [class.ciclo-vida-timeline__step--done]="etapa.fase < faseAtiva"
      >
        <span class="ciclo-vida-timeline__node">
          <i
            class="fas"
            [ngClass]="etapa.fase < faseAtiva ? 'fa-check' : etapa.icone"
            aria-hidden="true"
          ></i>
        </span>
        <span class="ciclo-vida-timeline__label">{{ etapa.label }}</span>
      </li>
    </ng-container>
  </ol>
</section>
